import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import AppTextField from "./AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppPhoneField',
  props: {
    modelValue: {},
    label: { default: "Phone" },
    placeholder: { default: "" },
    mask: { default: "(###) ###-####" },
    disabled: { type: Boolean, default: false },
    errorMessages: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const fieldProps = computed(() => ({
  label: props.label,
  placeholder: props.placeholder,
  disabled: props.disabled,
  errorMessages: props.errorMessages,
}));

return (_ctx: any,_cache: any) => {
  const _directive_mask = _resolveDirective("mask")!

  return _withDirectives((_openBlock(), _createBlock(AppTextField, _mergeProps(fieldProps.value, {
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }), null, 16, ["model-value"])), [
    [_directive_mask, __props.mask]
  ])
}
}

})